import { useTheme } from '@mui/material';
import { Layer, Source } from 'react-map-gl/maplibre';
import { Fragment } from 'react';

export function PathsSource({ type, data, visibility = 'visible' }) {
  const theme = useTheme();

  if (!data) {
    return null;
  }

  const starts = {
    type: 'FeatureCollection',
    features: data.features.map((feature) => ({
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: feature.geometry.coordinates[0],
      },
    })),
  };
  const ends = {
    type: 'FeatureCollection',
    features: data.features.map((feature) => ({
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates:
          feature.geometry.coordinates[feature.geometry.coordinates.length - 1],
      },
    })),
  };

  return (
    <Fragment>
      <Source id={`${type}-paths`} type="geojson" data={data}>
        <Layer
          id={`${type}-path-layer`}
          type="line"
          paint={{
            'line-color': theme.palette.common.black,
            'line-width': 2,
          }}
          layout={{
            'line-cap': 'round',
            'line-join': 'round',
            visibility,
          }}
        />
      </Source>
      <Source id={`${type}-starts`} type="geojson" data={starts}>
        <Layer
          id={`${type}-starts-layer`}
          type="circle"
          paint={{
            'circle-color': theme.palette.success.main,
            'circle-radius': ['interpolate', ['linear'], ['zoom'], 5, 2, 12, 4],
          }}
          layout={{ visibility }}
        />
      </Source>
      <Source id={`${type}-ends`} type="geojson" data={ends}>
        <Layer
          id={`${type}-ends-layer`}
          type="circle"
          paint={{
            'circle-color': theme.palette.error.main,
            'circle-radius': ['interpolate', ['linear'], ['zoom'], 5, 2, 12, 4],
          }}
          layout={{ visibility }}
        />
      </Source>
    </Fragment>
  );
}
